import React, { useState, useEffect } from "react";
import { Container, Table, Form, Row, Col, Button} from "react-bootstrap";
import { useProducts } from "../ProductContext";
import { useOrders } from "../OrderContext";
import {useNavigate} from "react-router-dom";

const ProductsReport = () => {
    const { fetchAllProducts } = useProducts();
    const { orders, fetchOrders } = useOrders();

    const [ startDate, setStartDate ] = useState("");
    const [ endDate, setEndDate ] = useState("");
    const [ productFilter, setProductFilter ] = useState("");

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        fetchAllProducts();
        fetchOrders();
    }, [fetchAllProducts, fetchOrders]);

    // filter orders based on range
    const filteredOrders = orders.filter((order) => {
        const orderDate = new Date(order.created_at);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        return (
            (!start || orderDate >= start) &&
            (!end || orderDate <= end)
        );
    });

    // aggregate product data
    const productData = {};

    filteredOrders.forEach(order => {
        order.items.forEach(item => {
            const productId = item.product_details.id;
            const productName = item.product_details.product_name;
            const quantity = parseFloat(item.quantity) || 0;
            const returnedQuantity = parseFloat(item.returned_quantity) || 0;

            if (!productData[productId]) {
                productData[productId] = {
                    sku: productId,
                    name: productName,
                    quantitySold: 0,
                    orderCount: 0,
                };
            }
            productData[productId].quantitySold += (quantity - returnedQuantity);
            productData[productId].orderCount += 1;
        });
    });

    // convert to array and apply product filter
    const productDataArray = Object.values(productData).filter(product => {
        return product.name.toLowerCase().includes(productFilter.toLowerCase());
    })
        .sort((a, b) => b.orderCount - a.orderCount); // sort by order count

    return (
        <>
            <div className="back-button-container">
                <Button variant="danger" onClick={handleBack}>Back</Button>
            </div>
            <Container className="mt-5">
                <h1>Products Report</h1>
                <Form>
                    <Row>
                        <Col ms={4}>
                            <Form.Group controlId="startDate">
                                <Form.Label>Start Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>End Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="productsFilter">
                                <Form.Label>Product Filter</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search by product name"
                                    value={productFilter}
                                    onChange={(e) => setProductFilter(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>SKU</th>
                            <th>Product Name</th>
                            <th>Quantity Sold</th>
                            <th>Order Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productDataArray.map(product => (
                            <tr key={product.sku}>
                                <td>{product.sku}</td>
                                <td>{product.name}</td>
                                <td>{product.quantitySold}</td>
                                <td>{product.orderCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>
    );
};

export default ProductsReport;